import { TFunction } from 'client/i18n/hooks/useT';

const buttonCopy = {
  SAVE_DRAFT: (t: TFunction) =>
    t('Button.SaveAsDraft', 'Save as draft', 'Save as draft button text'),
  UPDATE_DRAFT: (t: TFunction) =>
    t(
      'Button.UpdateSavedDraft',
      'Update saved draft',
      'Update saved draft button text'
    ),
  REVERT_DRAFT: (t: TFunction) =>
    t('Button.RevertToDraft', 'Revert to draft', 'Revert to draft button text'),
  SAVING: (t: TFunction) =>
    t('Button.Saving', 'Saving...', 'Saving button text'),
  SUBMITTING: (t: TFunction) =>
    t('Button.Submitting', 'Submitting...', 'Submitting button text'),
  SPOTIFY_EXCLUSIVE_PUBLISH: (t: TFunction) =>
    t('Button.Publish', 'Publish', 'Publish button text'),
  NEEDS_REVIEW: (t: TFunction) =>
    t(
      'Button.SubmitEpisodeForReview',
      'Submit episode for review',
      'Submit episode for review button text'
    ),
  PUBLISH: (t: TFunction) =>
    t('Button.PublishNow', 'Publish now', 'Publish now button text'),
  PUBLISHING: (t: TFunction) =>
    t('Button.Publishing', 'Publishing...', 'Publishing button text'),
  NEXT: (t: TFunction) => t('Button.Next', 'Next', 'Next button text'),
  UPDATE_EPISODE: (t: TFunction) =>
    t('Button.UpdateEpisode', 'Update episode', 'Update episode button text'),
  UPDATING: (t: TFunction) =>
    t('Button.Updating', 'Updating...', 'Updating button text'),
  SCHEDULE_EPISODE: (t: TFunction) =>
    t(
      'Button.ScheduleEpisode',
      'Schedule episode',
      'Schedule episode button text'
    ),
  SCHEDULING: (t: TFunction) =>
    t('Button.Scheduling', 'Scheduling...', 'Scheduling button text'),
};

type ButtonStatus = keyof typeof buttonCopy;

export function getButtonCopy(status: ButtonStatus, t: TFunction) {
  return buttonCopy[status](t);
}
